<script setup lang="ts">
//#region types
interface Props {
  error?: boolean;
}
//#endregion

//#region define
withDefaults(defineProps<Props>(), {
  error: false,
});
//#endregion
</script>

<template>
  <div class="crm-panel">
    <div
      class="crm-panel__content-wrapper"
      :class="{
        'crm-panel__content-wrapper_error': error,
      }"
    >
      <slot name="prepend" />
      <div class="crm-panel__content">
        <slot />
      </div>
      <slot name="append" />
    </div>
  </div>
</template>

<style lang="scss">
.crm-panel {
  &__content-wrapper {
    display: flex;
    color: var(--text-body);
    border-radius: 8px;
    background: var(--background-body);
    .crm-panel__content {
      padding: 8px 16px;
    }
  }

  &__content {
    display: flex;
    flex-grow: 1;
    min-width: 0;
  }
}
</style>
